import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { REBALANCE_PARKING_LEGEND } from '../../../constants/legends';

const RebalanceParkingLegendComponent = () => (
    <div>
        <LegendRenderer config={REBALANCE_PARKING_LEGEND} />
    </div>
);

export const RebalanceParkingLegend = withDisplayedLayersCheck(
    RebalanceParkingLegendComponent,
    t`Прогноз ребаланса парковок`
);
